<template>
  <Business v-if="isLp && currentLp === 'Business'" />
  <BusinessCard v-else-if="isLp && currentLp === 'BusinessCard'" />
  <ExcelVba v-else-if="isLp && currentLp === 'ExcelVba'" />
  <FortuneTelling v-else-if="isLp && currentLp === 'FortuneTelling'" />
  <Health v-else-if="isLp && currentLp === 'Health'" />
  <HomePage v-else-if="isLp && currentLp === 'HomePage'" />
  <ImageDesign v-else-if="isLp && currentLp === 'ImageDesign'" />
  <ImageDesignMapCreating v-else-if="isLp && currentLp === 'ImageDesignMapCreating'" />
  <MovieProduction v-else-if="isLp && currentLp === 'MovieProduction'" />
  <NarrationVoice v-else-if="isLp && currentLp === 'NarrationVoice'" />
  <Portrait v-else-if="isLp && currentLp === 'Portrait'" />
  <Seo v-else-if="isLp && currentLp === 'Seo'" />
  <Translation v-else-if="isLp && currentLp === 'Translation'" />
  <Writing v-else-if="isLp && currentLp === 'Writing'" />
</template>
<script>
import { findKey } from 'lodash-es'
import { mapGetters } from 'vuex'

// LPを表示するカテゴリID
/**
 * from_adがある時に表示するLP(ONLY_FROM_AD_CATEGORY_IDS)以外を非表示中
 * https://github.com/welself/web-ui-components/pull/258
 */
const TARGET_CATEGORY_IDS = {
  Business: [], // [13, 270, 271, 272, 274, 276, 278, 279, 427, 429, 434, 435, 437, 438, 623, 627],
  BusinessCard: [], // [357],
  FortuneTelling: [], // [70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 416, 417, 419, 420, 424, 426, 445, 642],
  ExcelVba: [], // [230],
  Health: [], // [2, 50, 51, 59],
  HomePage: [], // [355, 501, 502, 503, 504, 505, 507, 510, 611, 644],
  ImageDesign: [351], // [18, 351, 354, 356, 359, 360, 361, 362, 363, 364, 365, 366, 608],
  ImageDesignMapCreating: [], // [358],
  MovieProduction: [], // [10, 210, 211, 219, 220, 610],
  NarrationVoice: [], // [215],
  Portrait: [9, 190, 191, 192],
  Seo: [], // [16, 310, 312, 313, 314, 315],
  Translation: [], // [14, 290, 291, 292, 293, 295, 616, 617, 618],
  Writing: [] // [19, 370, 371, 372, 613, 646]
}

// LPを表示するカテゴリID
// 指定した親カテゴリとその配下のすべての子カテゴリも対象にする
// TARGET_CATEGORY_IDSよりも優先
const TARGET_PARENT_CATEGORY_IDS = {}

// from_adパラメータがないときはLPを表示しないカテゴリID
const ONLY_FROM_AD_CATEGORY_IDS = [9, 190, 191, 192, 351]

// from_adパラメータがないときはLPを表示しないカテゴリID
// 指定した親カテゴリとその配下のすべての子カテゴリも対象にする
// 電話相談サービスに絞り込んだときのみ有効
// ONLY_FROM_AD_CATEGORY_IDSよりも優先
const ONLY_FROM_AD_PHONE_PARENT_CATEGORY_IDS = []

export default {
  name: 'SearchLp',
  components: {
    Business: () => import('./components/Business' /* webpackChunkName: "Business" */),
    BusinessCard: () => import('./components/BusinessCard' /* webpackChunkName: "BusinessCard" */),
    ExcelVba: () => import('./components/ExcelVba' /* webpackChunkName: "ExcelVba" */),
    FortuneTelling: () =>
      import('./components/FortuneTelling' /* webpackChunkName: "FortuneTelling" */),
    Health: () => import('./components/Health' /* webpackChunkName: "Health" */),
    HomePage: () => import('./components/HomePage' /* webpackChunkName: "HomePage" */),
    ImageDesign: () => import('./components/ImageDesign' /* webpackChunkName: "ImageDesign" */),
    ImageDesignMapCreating: () =>
      import('./components/ImageDesignMapCreating' /* webpackChunkName: "ImageDesignMapCreating" */),
    MovieProduction: () =>
      import('./components/MovieProduction' /* webpackChunkName: "MovieProduction" */),
    NarrationVoice: () =>
      import('./components/NarrationVoice' /* webpackChunkName: "NarrationVoice" */),
    Portrait: () => import('./components/Portrait' /* webpackChunkName: "Portrait" */),
    Seo: () => import('./components/Seo' /* webpackChunkName: "Seo" */),
    Translation: () => import('./components/Translation' /* webpackChunkName: "Translation" */),
    Writing: () => import('./components/Writing' /* webpackChunkName: "Writing" */)
  },
  props: {
    currentCategoryId: {
      type: Number,
      default: 0
    },
    parentCategoryId: {
      type: Number,
      default: 0
    },
    serviceClass: {
      type: Number,
      default: 0
    },
    isLp: {
      type: Boolean,
      default: false
    },
    isFromAd: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn']),
    isPhone() {
      return this.serviceClass === this.$store.state.constants.serviceClass.phone
    },
    currentLp() {
      if (
        this.isPhone &&
        ONLY_FROM_AD_PHONE_PARENT_CATEGORY_IDS.includes(this.parentCategoryId) &&
        !this.isFromAd
      ) {
        return null
      }

      if (ONLY_FROM_AD_CATEGORY_IDS.includes(this.currentCategoryId) && !this.isFromAd) {
        return null
      }

      const targetParentCategoryId = findKey(TARGET_PARENT_CATEGORY_IDS, o =>
        o.includes(this.parentCategoryId)
      )
      if (targetParentCategoryId) {
        return targetParentCategoryId
      }

      const targetCategoryId = findKey(TARGET_CATEGORY_IDS, o => o.includes(this.currentCategoryId))
      if (targetCategoryId) {
        return targetCategoryId
      }

      return null
    }
  }
}
</script>
<style lang="scss" scoped>
/deep/ * {
  box-sizing: content-box;
}

/deep/ p {
  margin: 0;
}

/deep/ .bl_category-jumbotron {
  position: relative;
  z-index: 0;
  margin: 20px auto;
  padding: 0 45px 45px;
  width: 950px;
  background-color: $color-white;

  .button-flat-basic {
    $drop-shadow-size: 3px;

    display: inline-block;
    box-sizing: border-box;
    margin-bottom: 0;
    padding: 13px 24px;
    width: 100%;
    border: 1px solid $color-gray-100;
    border-bottom-width: $drop-shadow-size;
    border-radius: 5px;
    background-color: white;
    vertical-align: middle;
    text-align: center;
    white-space: nowrap;
    font-weight: bold;
    font-size: 30px;
    line-height: 1.5;
    cursor: pointer;

    user-select: none;

    &:active {
      margin-top: $drop-shadow-size;
      border-bottom-width: 0;
    }

    &.button-flat-large {
      $drop-shadow-size-large: 4px;

      border-bottom-width: $drop-shadow-size-large;

      &:active {
        margin-top: $drop-shadow-size-large;
        border-bottom-width: 0;
      }
    }

    i {
      margin-right: 0;
      margin-left: 10px;
      vertical-align: -1px;

      &.-chevron-right {
        font-size: 25px;
      }
    }
  }

  .button-flat-green {
    border-color: #8ec31f;
    border-bottom-color: #729c19;
    background-color: #8ec31f;
    color: #fff;
  }

  .button-flat-orange {
    border-color: #feb032;
    border-bottom-color: #e67224;
    background-color: #feb032;
    color: $color-white;
  }

  .lp-register-button {
    text-align: center;

    a {
      width: 450px;
      vertical-align: middle;
    }

    .detail-text {
      margin: 15px auto;
      width: 400px;
      text-align: left;
      font-size: 12px;
    }
  }

  .about-coconala {
    width: 950px;

    .bl_number {
      display: flex;
      margin: 0 auto;
      padding-top: 230px;
      width: 450px;

      align-items: flex-end;
      justify-content: space-between;

      @mixin number-background($file-name) {
        width: 140px;
        background: url('~assets/images/components/SearchLp/#{$file-name}.png') 0 0 no-repeat;
        background-size: contain;
        text-align: center;

        .number-text {
          color: $color-pink-500;
          font-weight: bold;
          font-size: 20px;

          .number-text-number {
            font-size: 32px;
          }
        }
      }

      .number-user {
        @include number-background('number_user');

        height: 162px;

        .number-text {
          margin-top: 80px;
        }
      }

      .number-service {
        @include number-background('number_service');

        height: 173px;

        .number-text {
          margin-top: 91px;
        }
      }

      .number-transaction {
        @include number-background('number_transaction');

        height: 173px;

        .number-text {
          margin-top: 91px;
        }
      }
    }
  }

  .item-group {
    margin: 0 auto 20px;
    width: 92%;

    &:last-child {
      margin-bottom: 0;
    }

    &.modi_full-width {
      width: 100%;
    }

    .content {
      margin-bottom: 40px;
    }

    .footer-lp {
      margin: 0 auto;
      width: 550px;

      p {
        margin: 20px auto 0;
        width: 360px;
      }
    }
  }
}

/deep/ .bl_category-jumbotron-full {
  margin: 20px auto;
  background-color: $color-white;

  .lp-register-button {
    text-align: center;

    a {
      width: 450px;
      vertical-align: middle;
    }
  }

  .item-group {
    margin: 0 auto 20px;
    width: 92%;

    &:last-child {
      margin-bottom: 0;
    }

    &.modi_full-width {
      width: 100%;
    }

    .content {
      margin-bottom: 40px;
    }

    .footer-lp {
      margin: 0 auto;
      width: 550px;

      p {
        margin: 20px auto 0;
        width: 360px;
      }
    }
  }
}

/deep/ .bl_category-jumbotron-sp {
  .bl_full-image-box {
    > img {
      width: 100%;
    }
  }

  .bl_button-action {
    display: block;
    box-sizing: border-box;
    margin: 14px 10px;
    padding: 12px 0;
    border-radius: 5px;
    text-align: center;
    font-weight: bold;
    font-size: 14px;

    &.modi_button-green {
      border: 1px solid #7baa17;
      background-color: #8ec31f;
      background-image: linear-gradient(to bottom, #9ed947, #8ec33f);
      background-image: -webkit-gradient(linear, left top, left bottom, from(#9ed947), to(#8ec33f));
      color: #fff;
    }

    &.modi_button-xlarge {
      padding: 20px 0;
      font-size: 18px;
    }
  }

  .bl_button-submit {
    position: relative;
    display: block;
    box-sizing: border-box;
    margin: 0;
    padding: 10px 0;
    width: 100%;
    border: 1px solid #7baa17;
    border-radius: 5px;
    background-color: #8ec31f;
    background-image: linear-gradient(to bottom, #9ed947, #8ec33f);
    color: #fff;
    text-align: center;
    font-weight: bold;
    font-size: 14px;
    line-height: 22px;
  }

  .item-group {
    padding-bottom: 20px;

    &.modi_bg-gray {
      background-color: #f5f5f5;
    }
  }

  .description {
    margin-bottom: 20px;
    text-align: center;

    .register-button {
      margin: 20px 0 0;
    }
  }

  .content {
    padding: 0 10px 20px;

    &.modi_full-width {
      padding-right: 0;
      padding-left: 0;
    }
  }

  .footer-lp {
    .bl_button-action {
      margin: 0 10px;
    }

    p {
      padding: 20px 10px 0;
      text-align: left;
    }
  }

  .about-coconala {
    position: relative;
    padding-top: 84%;
    width: 100%;
    height: 0;

    .bl_number-outer {
      margin: 0 auto;
      width: 290px;

      .bl_number {
        position: absolute;
        top: 59%;
        display: flex;
        width: 290px;

        align-items: flex-end;
        justify-content: space-around;

        @mixin number-background($file-name) {
          width: 90px;
          background: url('~assets/images/components/SearchLp/sp/#{$file-name}.png') 0 0 no-repeat;
          background-size: contain;
          text-align: center;

          .number-text {
            color: $color-pink-500;
            font-weight: bold;
            font-size: 14px;

            .number-text-number {
              font-size: 20px;
            }
          }
        }

        .number-user {
          @include number-background('number_user');

          height: 104px;

          .number-text {
            margin-top: 60px;
          }
        }

        .number-service {
          @include number-background('number_service');

          height: 111px;

          .number-text {
            margin-top: 67px;
          }
        }

        .number-transaction {
          @include number-background('number_transaction');

          height: 111px;

          .number-text {
            margin-top: 67px;
          }
        }
      }
    }
  }
}

/deep/ .c-btn {
  display: inline-block;
  box-sizing: border-box;
  border: 1px solid;
  border-radius: 5px;
  text-align: center;
  font-weight: bold;
  cursor: pointer;

  -webkit-appearance: none;

  &:hover {
    opacity: 0.7;
  }

  @mixin c-btn-size($height, $font-size) {
    padding: 0 $font-size;
    height: $height;
    font-size: $font-size;
    line-height: $height - 2px;
  }

  &.c-btn-ll {
    @include c-btn-size(60px, 20px);
  }

  &.c-btn-l {
    @include c-btn-size(54px, 18px);
  }

  &.c-btn-m {
    @include c-btn-size(44px, 14px);
  }

  &.c-btn-primary {
    border-color: $color-green-600 $color-green-600 $color-green-800;
    background-color: $color-green-500;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.3);
    color: $color-white;
  }

  .coconala-icon {
    vertical-align: middle;
  }
}

/deep/ .wa_add-pt-4 {
  padding-top: 4px !important;
}
/deep/ .wa_add-pt-6 {
  padding-top: 6px !important;
}
/deep/ .wa_add-pt-8 {
  padding-top: 8px !important;
}
/deep/ .wa_add-pt-10 {
  padding-top: 10px !important;
}
/deep/ .wa_add-pt-11 {
  padding-top: 11px !important;
}
/deep/ .wa_add-pt-14 {
  padding-top: 14px !important;
}
/deep/ .wa_add-pt-15 {
  padding-top: 15px !important;
}
/deep/ .wa_add-pt-17 {
  padding-top: 17px !important;
}
/deep/ .wa_add-pt-20 {
  padding-top: 20px !important;
}
/deep/ .wa_add-pt-25 {
  padding-top: 25px !important;
}
/deep/ .wa_add-pt-30 {
  padding-top: 30px !important;
}
/deep/ .wa_add-pt-50 {
  padding-top: 50px !important;
}

/deep/ .wa_add-pb-4 {
  padding-bottom: 4px !important;
}
/deep/ .wa_add-pb-6 {
  padding-bottom: 6px !important;
}
/deep/ .wa_add-pb-8 {
  padding-bottom: 8px !important;
}
/deep/ .wa_add-pb-10 {
  padding-bottom: 10px !important;
}
/deep/ .wa_add-pb-11 {
  padding-bottom: 11px !important;
}
/deep/ .wa_add-pb-12 {
  padding-bottom: 12px !important;
}
/deep/ .wa_add-pb-15 {
  padding-bottom: 15px !important;
}
/deep/ .wa_add-pb-17 {
  padding-bottom: 17px !important;
}
/deep/ .wa_add-pb-20 {
  padding-bottom: 20px !important;
}
/deep/ .wa_add-pb-25 {
  padding-bottom: 25px !important;
}
/deep/ .wa_add-pb-30 {
  padding-bottom: 30px !important;
}
/deep/ .wa_add-pb-40 {
  padding-bottom: 40px !important;
}
/deep/ .wa_add-pb-50 {
  padding-bottom: 50px !important;
}

/deep/ .wa_add-mt-2 {
  margin-top: 2px !important;
}
/deep/ .wa_add-mt-3 {
  margin-top: 3px !important;
}
/deep/ .wa_add-mt-4 {
  margin-top: 4px !important;
}
/deep/ .wa_add-mt-6 {
  margin-top: 6px !important;
}
/deep/ .wa_add-mt-8 {
  margin-top: 8px !important;
}
/deep/ .wa_add-mt-9 {
  margin-top: 9px !important;
}
/deep/ .wa_add-mt-10 {
  margin-top: 10px !important;
}
/deep/ .wa_add-mt-12 {
  margin-top: 12px !important;
}
/deep/ .wa_add-mt-14 {
  margin-top: 14px !important;
}
/deep/ .wa_add-mt-15 {
  margin-top: 15px !important;
}
/deep/ .wa_add-mt-16 {
  margin-top: 16px !important;
}
/deep/ .wa_add-mt-20 {
  margin-top: 20px !important;
}
/deep/ .wa_add-mt-25 {
  margin-top: 25px !important;
}
/deep/ .wa_add-mt-30 {
  margin-top: 30px !important;
}
/deep/ .wa_add-mt-40 {
  margin-top: 40px !important;
}
/deep/ .wa_add-mt-50 {
  margin-top: 50px !important;
}
/deep/ .wa_add-mt-60 {
  margin-top: 60px !important;
}

/deep/ .wa_add-mb-3 {
  margin-bottom: 3px !important;
}
/deep/ .wa_add-mb-4 {
  margin-bottom: 4px !important;
}
/deep/ .wa_add-mb-5 {
  margin-bottom: 5px !important;
}
/deep/ .wa_add-mb-6 {
  margin-bottom: 6px !important;
}
/deep/ .wa_add-mb-8 {
  margin-bottom: 8px !important;
}
/deep/ .wa_add-mb-10 {
  margin-bottom: 10px !important;
}
/deep/ .wa_add-mb-12 {
  margin-bottom: 12px !important;
}
/deep/ .wa_add-mb-14 {
  margin-bottom: 14px !important;
}
/deep/ .wa_add-mb-16 {
  margin-bottom: 16px !important;
}
/deep/ .wa_add-mb-18 {
  margin-bottom: 18px !important;
}
/deep/ .wa_add-mb-20 {
  margin-bottom: 20px !important;
}
/deep/ .wa_add-mb-30 {
  margin-bottom: 30px !important;
}
/deep/ .wa_add-mb-40 {
  margin-bottom: 40px !important;
}
/deep/ .wa_add-mb-50 {
  margin-bottom: 50px !important;
}
/deep/ .wa_add-mb-60 {
  margin-bottom: 60px !important;
}

/deep/ .wa_fz-10 {
  font-size: 10px !important;
}
/deep/ .wa_fz-11 {
  font-size: 11px !important;
}
/deep/ .wa_fz-12 {
  font-size: 12px !important;
}
/deep/ .wa_fz-13 {
  font-size: 13px !important;
}
/deep/ .wa_fz-14 {
  font-size: 14px !important;
}
/deep/ .wa_fz-15 {
  font-size: 15px !important;
}
/deep/ .wa_fz-16 {
  font-size: 16px !important;
}
/deep/ .wa_fz-17 {
  font-size: 17px !important;
}
/deep/ .wa_fz-18 {
  font-size: 18px !important;
}
/deep/ .wa_fz-19 {
  font-size: 19px !important;
}
/deep/ .wa_fz-20 {
  font-size: 20px !important;
}
/deep/ .wa_fz-24 {
  font-size: 24px !important;
}

/deep/ .wa_del-bold {
  font-weight: normal !important;
}

/deep/ .wa_ta-center {
  text-align: center !important;
}
</style>
